var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTravel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 67 67",
    style: {
      enableBackground: "new 0 0 67 67"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A6A6F7;}\n\t.st1{fill:#E3F2FF;}\n\t.st2{fill:#7ADDB6;}\n\t.st3{fill:#4343B5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "18.5,17.1 22.6,16.9 22.6,8.9 44.3,8.7 44.3,17.1 48.9,17.1 48.4,7.1 45,4.4 36.4,4.4 21.3,4.6  18.5,7.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.2,62H8c-2.4,0-4.3-1.9-4.3-4.3V21.5c0-2.4,1.9-4.3,4.3-4.3h51.2c2.4,0,4.3,1.9,4.3,4.3v36.2 C63.5,60,61.6,62,59.2,62z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 22.6,
    className: "st2",
    width: 6.9,
    height: 15.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.3,17.2h-3c-1.6,0-2.9,1.3-2.9,2.9v3c0,1.6,1.3,2.9,2.9,2.9h3c1.6,0,2.9-1.3,2.9-2.9v-3 C12.2,18.5,10.9,17.2,9.3,17.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61,17.2h-3c-1.6,0-2.9,1.3-2.9,2.9v3c0,1.6,1.3,2.9,2.9,2.9h3c1.6,0,2.9-1.3,2.9-2.9v-3 C63.9,18.5,62.6,17.2,61,17.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61,53.9h-3c-1.6,0-2.9,1.3-2.9,2.9v3c0,1.6,1.3,2.9,2.9,2.9h3c1.6,0,2.9-1.3,2.9-2.9v-3 C63.9,55.2,62.6,53.9,61,53.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.3,53.9h-3c-1.6,0-2.9,1.3-2.9,2.9v3c0,1.6,1.3,2.9,2.9,2.9h3c1.6,0,2.9-1.3,2.9-2.9v-3 C12.2,55.2,10.9,53.9,9.3,53.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M63.6,61.5c0.7-0.9,1.1-2,1.1-3.2V21.7c0-3-2.4-5.4-5.4-5.4h-9.7V8.7c0-3-2.4-5.4-5.4-5.4H22.7 c-3,0-5.4,2.4-5.4,5.4v7.5H7.6c-3,0-5.4,2.4-5.4,5.4v36.6c0,1.2,0.4,2.3,1.1,3.2H0.1v2.2h7.5h51.7h7.5v-2.2H63.6z M62.6,51.8v1.1 h-3.2c-3,0-5.4,2.4-5.4,5.4v3.2H13v-3.2c0-3-2.4-5.4-5.4-5.4H4.4V27h3.2c3,0,5.4-2.4,5.4-5.4v-3.2h5.4v3.2h-2.2 c-0.6,0-1.1,0.5-1.1,1.1v15.1c0,0.6,0.5,1.1,1.1,1.1h6.5c0.6,0,1.1-0.5,1.1-1.1V22.7c0-0.6-0.5-1.1-1.1-1.1h-2.2v-3.2H54v3.2 c0,3,2.4,5.4,5.4,5.4h3.2v16.2 M21.7,23.8v12.9h-4.3V23.8H21.7z M43.2,16.3H23.8V9.8h19.4V16.3z M62.6,21.7v3.2h-3.2 c-1.8,0-3.2-1.4-3.2-3.2v-3.2h3.2C61.1,18.4,62.6,19.9,62.6,21.7z M19.5,8.7c0-1.8,1.4-3.2,3.2-3.2h21.5c1.8,0,3.2,1.4,3.2,3.2 v7.5h-2.2V8.7c0-0.6-0.5-1.1-1.1-1.1H22.7c-0.6,0-1.1,0.5-1.1,1.1v7.5h-2.2V8.7z M7.6,18.4h3.2v3.2c0,1.8-1.4,3.2-3.2,3.2H4.4 v-3.2C4.4,19.9,5.9,18.4,7.6,18.4z M4.4,58.3V55h3.2c1.8,0,3.2,1.4,3.2,3.2v3.2H7.6C5.9,61.5,4.4,60.1,4.4,58.3z M56.1,61.5v-3.2 c0-1.8,1.4-3.2,3.2-3.2h3.2v3.2c0,1.8-1.4,3.2-3.2,3.2H56.1z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravel);
export default __webpack_public_path__ + "static/media/travel.c0f9c6fc1621483dee82b02789e0e64b.svg";
export { ForwardRef as ReactComponent };